import React from "react";

const ClubCustomersIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.19029 11.089C6.11317 11.089 4.42285 9.17128 4.42285 6.81452C4.42285 4.45776 6.11262 2.54004 8.19029 2.54004C10.268 2.54004 11.9577 4.45776 11.9577 6.81452C11.9577 9.17128 10.268 11.089 8.19029 11.089ZM8.19029 3.13848C6.44285 3.13848 5.02129 4.78745 5.02129 6.81452C5.02129 8.84159 6.44285 10.4906 8.19029 10.4906C9.93773 10.4906 11.3593 8.84159 11.3593 6.81452C11.3593 4.78745 9.93773 3.13848 8.19029 3.13848Z"
        fill="currentColor"
      />
      <path
        d="M2.87522 21.719H1.10059V16.8662C1.10059 14.1395 3.31915 11.9209 6.04586 11.9209V12.5193C3.64884 12.5193 1.69902 14.4692 1.69902 16.8662V21.1205H2.87522V21.719Z"
        fill="currentColor"
      />
      <path
        d="M14.8488 21.719H5.34668V21.1205H14.2504V16.8662C14.2504 14.4692 12.3005 12.5193 9.90351 12.5193V11.9209C12.6302 11.9209 14.8488 14.1395 14.8488 16.8662V21.719Z"
        fill="currentColor"
      />
      <path
        d="M16.5329 10.3651C14.5483 10.3651 12.9336 8.53385 12.9336 6.28263C12.9336 4.03142 14.5483 2.2002 16.5329 2.2002C18.5176 2.2002 20.1328 4.03142 20.1328 6.28263C20.1328 8.53385 18.5181 10.3651 16.5329 10.3651ZM16.5329 2.79863C14.878 2.79863 13.532 4.36165 13.532 6.28263C13.532 8.20362 14.8785 9.76663 16.5329 9.76663C18.1873 9.76663 19.5344 8.20362 19.5344 6.28263C19.5344 4.36165 18.1879 2.79863 16.5329 2.79863Z"
        fill="currentColor"
      />
      <path
        d="M12.7664 12.1024L12.5156 11.5589C13.1369 11.2722 13.8017 11.127 14.4916 11.127V11.7254C13.8893 11.7254 13.3088 11.8522 12.7664 12.1024Z"
        fill="currentColor"
      />
      <path
        d="M22.8825 20.48H16.3389V19.8816H22.2841V15.8475C22.2841 13.5746 20.4349 11.7254 18.1619 11.7254V11.127C20.7651 11.127 22.8825 13.2449 22.8825 15.8475V20.48Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ClubCustomersIcon;
